import {ReturnOrderProductData} from './IReturnOrderData';
import {PaymentDetails} from './IReturnOrderData';

/**
 * Represents ReturnOrderDataModel
 */
class ReturnOrderDataModel {
	private products: ReturnOrderProductData[] = [];
	private refundMethod: string;
	private bankAccountHolder: string;
	private beneficiaryBank: string;
	private BICSWIFTCode: string;
	private IBAN: string;
	private phoneNumber: string;

	/**
	 * @constructor
	 * @param {ReturnOrderProductData} productsData - products data
	 */
	constructor(productsData: ReturnOrderProductData[] | null) {
		this.products = productsData || [];
	}

	/**
	 * Sets refund method
	 * @param {string} method
	 */
	setRefundMethod(method: string) {
		this.refundMethod = method;
	}

	/**
	 * Sets bankAccountHolder
	 * @param {string} bankAccountHolder
	 */
	setBankAccountHolder(bankAccountHolder: string) {
		this.bankAccountHolder = bankAccountHolder;
	}

	/**
	 * Sets beneficiary bank's name
	 * @param {string} beneficiaryBank
	 */
	setBeneficiaryBank(beneficiaryBank: string) {
		this.beneficiaryBank = beneficiaryBank;
	}

	/**
	 * Sets BICSWIFTCode
	 * @param {string} BICSWIFTCode
	 */
	setBICSWIFTCode(BICSWIFTCode: string) {
		this.BICSWIFTCode = BICSWIFTCode;
	}

	/**
	 * Sets IBAN
	 * @param {string} IBAN
	 */
	setIBAN(IBAN: string) {
		this.IBAN = IBAN;
	}

	/**
	 * Sets phone number
	 * @param {string} phoneNumber
	 */
	setPhoneNumber(phoneNumber: string) {
		this.phoneNumber = phoneNumber;
	}

	/**
	 * Returns the array of ReturnOrderProductData
	 * @returns {ReturnOrderProductData[]}
	 */
	getProducts(): ReturnOrderProductData[]{
		return this.products;
	}

	/**
	 * Returns the refund method code string, such as STORE_CREDIT or CASH_ON_DELIVERY
	 * @returns {string}
	 */
	getRefundMethod(): string {
		return this.refundMethod ? this.refundMethod : '';
	}

	/**
	 * Returns phone number as a string
	 * @returns {string}
	 */
	getPhoneNumber(): string {
		return this.phoneNumber ? this.phoneNumber : '';
	}

	/**
	 * Returns PaymentDetails for this return order
	 * @returns {PaymentDetails}
	 */
	getPaymentDetails(): PaymentDetails {
		const bankAccountHolder = this.bankAccountHolder;
		const beneficiaryBank = this.beneficiaryBank;
		const BICSWIFTCode = this.BICSWIFTCode;
		const IBAN = this.IBAN;
		const data = {bankAccountHolder, beneficiaryBank, BICSWIFTCode, IBAN};

		return data;
	}
}

export default ReturnOrderDataModel;
